<template>
    <flex-element class-default-inline="f-relative" :tag="renderedTag">
        <slot :element="element" :elements-new="elementsNew" :element-updated="elementUpdated" />
    </flex-element>
</template>

<script>
import baseOrganism from '@/mixins/base-organism/base-organism-dumb';

export default {
    name: 'tab-container',
    mixins: [baseOrganism],

    props: {
        tag: {
            type: String,
            default: 'div',
        },
    },

    computed: {
        renderedTag() {
            return this.tag || 'div';
        },
    },
};
</script>
